import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

export { default as NumberField } from './NumberField.vue';
export { default as NumberFieldContent } from './NumberFieldContent.vue';
export { default as NumberFieldDecrement } from './NumberFieldDecrement.vue';
export { default as NumberFieldIncrement } from './NumberFieldIncrement.vue';
export { default as NumberFieldInput } from './NumberFieldInput.vue';
export { default as NumericText } from './NumericText.vue';

export const numberFieldInputVariants = cva(
  'flex w-full rounded-sm border border-input bg-background dark:bg-input/30 py-1 transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
  {
    defaultVariants: {
      size: 'default',
      align: 'center',
    },
    variants: {
      align: {
        left: 'text-left pl-2',
        right: 'text-right pr-2',
        center: 'text-center',
      },
      size: {
        default: 'h-9 text-xs',
        lg: 'h-10 text-sm',
        sm: 'h-8 text-xs',
        xl: 'h-12 text-sm',
      },
    },
  },
);

export type NumberFieldInputVariants = VariantProps<typeof numberFieldInputVariants>;
